import { createFileRoute } from "@tanstack/react-router";
import { UserPlus, Mail, Wallet, Lock, QrCode, PenLine } from "lucide-react";
import { PlatformHub } from "@/components/marketing/PlatformHub";
import { alternateLinkList } from "@/lib/i18n/locale";
import heroImg from "@/assets/cards-sharing.webp";

export const Route = createFileRoute("/vi/platform/networking/")({
  head: () => ({
    meta: [
      { title: "Công cụ chia sẻ & networking — banana.cards" },
      { name: "description", content: "Mọi cách chia sẻ thẻ và capture lead: QR, Apple & Google Wallet, signature email, form trao đổi, welcome email và thẻ bảo vệ PIN." },
      { property: "og:title", content: "Công cụ chia sẻ & networking — banana.cards" },
      { property: "og:description", content: "QR, Wallet, trao đổi lead, welcome email, PIN và signature." },
      { property: "og:image", content: heroImg },
      { property: "og:locale", content: "vi_VN" },
    ],
    links: alternateLinkList("/platform/networking", "vi"),
  }),
  component: Page,
});

function Page() {
  return (
    <PlatformHub
      eyebrow="Chia sẻ & Networking"
      title="Mọi cách chia sẻ,"
      italic="mọi cách capture."
      description="Sáu công cụ networking trên thẻ Banana — để mỗi tap, scan hay click luôn trở thành contact được lưu, follow-up và mối quan hệ."
      heroImage={heroImg}
      features={[
        { title: "Trao đổi liên hệ", desc: "Form 2 chiều trên mọi thẻ — họ nhận liên hệ của bạn, bạn nhận của họ, vào CRM.", href: "/vi/platform/networking/lead-exchange", icon: UserPlus, bullets: ["Trường tùy chỉnh", "Auto-sync vào CRM", "GDPR consent có sẵn"] },
        { title: "Welcome Email", desc: "Gửi email chào cá nhân hoá ngay khi ai đó scan thẻ — tự động.", href: "/vi/platform/networking/welcome-email", icon: Mail, bullets: ["Trigger khi tap lần đầu", "Biến cá nhân hoá", "Track opens & clicks"] },
        { title: "Apple & Google Wallet", desc: "Đưa thẻ vào Wallet của người nhận — luôn ở tay, luôn đồng bộ.", href: "/vi/platform/networking/wallet", icon: Wallet, bullets: ["Pass iOS & Android", "Cập nhật live", "Không cài app"] },
        { title: "Bảo vệ PIN", desc: "Khóa thẻ nhạy cảm bằng PIN — hoàn hảo cho hồ sơ executive, pháp lý hay y tế.", href: "/vi/platform/networking/pin-protection", icon: Lock, bullets: ["PIN mỗi thẻ", "Đổi bất cứ lúc nào", "Audit log"] },
        { title: "QR Code", desc: "QR contrast cao, branded cho mọi thẻ — in, chiếu, dán ở đâu cũng được.", href: "/vi/platform/networking/qr-code", icon: QrCode, bullets: ["Màu & logo branded", "Export PNG/SVG/PDF", "Scan được tracked"] },
        { title: "Signature email", desc: "Signature HTML đẹp mirror thẻ — cho Gmail, Outlook và Apple Mail.", href: "/vi/platform/networking/email-signature", icon: PenLine, bullets: ["Cài 1-click", "Luôn đồng bộ", "Template team"] },
      ]}
      outro={{ title: "Biến mỗi tap", italic: "thành cuộc trò chuyện.", description: "Sáu công cụ, một thẻ, không ma sát — để không gì rơi rớt." }}
    />
  );
}